import { microActivityList } from "constants/microActivity";

const initialState = {
  microActivityList: {},
};

const microActivity = (state = initialState, action) => {
  switch (action.type) {
    case microActivityList:
      return { ...state, microActivityList: action.payload };

    default:
      return state;
  }
};
export default microActivity;
